import styled from 'styled-components/macro'
import { CircularProgress } from '@material-ui/core'

export const Loading = styled(CircularProgress)`
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -12px;
  margin-left: -12px;
`
